module.exports = __webpack_public_path__ + "img/half.59cea6dc.png";